import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { Editor } from "components/shared/Editor";
import { addService } from "store/actions";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { getId } from "helpers/functions";
import ImageUploadEn from "./ImageUploadEn";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toast } from "react-toastify";

const AddService = () => {
  const [selectedMainImage, setSelectedMainImage] = useState();
  const [description, setDescription] = useState({ ar: "", en: "" });
  const [tags, setTags] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { locale } = useIntl();

  const [selectedIcon, setSelectedIcon] = useState();

  // const { blogCategories } = useSelector((state) => state.blogCategories);


  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    // dispatch(getBlogCategories());
  }, [dispatch]);


  // const renderCategoriesOptions = blogCategories?.map((category) => (
  //   <option value={getId(category)}>{category?.title?.[locale]}</option>
  // ));



  const onSubmit = async (data) => {


    try {
      if (selectedMainImage) data.image = selectedMainImage.path;
      if (selectedIcon) data.icon = selectedIcon.path;

      data.description = description;

      await dispatch(addService({ page: "ourServices", data: { section: { title: data?.heading?.en, data } }, navigate, toast }));
    } catch (error) {
      console.error("Error submitting blog:", error);
    }
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="addServices" />
            </h4>
          </div>
          <div className="card-body form-group settings-tabs">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  {/* Main Image Upload */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5><FormattedMessage id="image" /></h5>
                      <ImageUploadEn
                        selectedImageEn={selectedMainImage}
                        setSelectedImageEn={setSelectedMainImage}
                        accept="image/*"
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5><FormattedMessage id="icon" /></h5>
                      <ImageUploadEn
                        selectedImageEn={selectedIcon}
                        setSelectedImageEn={setSelectedIcon}
                        accept="image/svg+xml, image/jpeg, image/png"
                      />
                    </div>
                  </Col>



                  {/* Title Inputs */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="title" />  (<FormattedMessage id="arabic-language" />) </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("heading.ar", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.heading?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="title" />  (<FormattedMessage id="english-language" />) </h5>

                      <input
                        type="text"
                        className="form-control"
                        {...register("heading.en", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.heading?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  {/* Title Inputs */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="subTitle" />  (<FormattedMessage id="arabic-language" />) </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("subHeading.ar", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.subHeading?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="subTitle" />  (<FormattedMessage id="english-language" />) </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("subHeading.en", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.subHeading?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>



                  {/* Description Editors */}
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="description" /> (<FormattedMessage id="arabic-language" />) </h5>
                      <Controller
                        control={control}
                        name="description.ar"
                        render={() => (
                          <Editor
                            initialValue=""
                            onChange={(e, editor) => {
                              const data = editor.getContent();
                              setDescription((prev) => ({
                                ...prev,
                                ar: data,
                              }));
                            }}
                          />
                        )}
                      />
                      <p className="error-hint">
                        {errors.description?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="description" /> (<FormattedMessage id="english-language" />) </h5>
                      <Controller
                        control={control}
                        name="description.en"
                        render={() => (
                          <Editor
                            initialValue=""
                            onChange={(e, editor) => {
                              const data = editor.getContent();
                              setDescription((prev) => ({
                                ...prev,
                                en: data,
                              }));
                            }}
                          />
                        )}
                      />
                      <p className="error-hint">
                        {errors.description?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>



                </Row>
              </Col>

              {/* Submit Button */}

              <SaveChangesButton addNew={true} />

            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddService;
